import { css } from '@linaria/core';
import theme from '../../theme';

const { pageHeaderHeight, adminContentPadding } = theme.constants;

export const productsPageClass = css`
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${pageHeaderHeight} - ${adminContentPadding} - ${adminContentPadding});
  overflow: hidden;
  background-color: #f8f9fa;

  @media (max-width: 768px) {
    height: auto;
    min-height: calc(100vh - ${pageHeaderHeight});
    overflow: visible;
    padding: 1rem;

  .page-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 3rem 2rem;
    text-align: center;

    h1 {
      margin: 0 0 1rem 0;
      font-size: 2.5rem;
      font-weight: 700;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .page-description {
      font-size: 1.1rem;
      max-width: 600px;
      margin: 0 auto;
      opacity: 0.95;
      line-height: 1.5;
    }
  }

  // Responsive design for mobile
  @media (max-width: 768px) {
    .page-header {
      padding: 2rem 1rem;

      h1 {
        font-size: 2rem;
      }

      .page-description {
        font-size: 1rem;
      }
    }
  }
`;